import React, { useState, useEffect, useMemo } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Link as DomLink,
  Link,
  useHistory,
  useLocation,
} from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import InfoIcon from "@mui/icons-material/Info";
import { connect, useDispatch, useSelector } from "react-redux";
import * as auth from "../../modules/Auth/_redux/authRedux";
import { getHotel } from "../../modules/Auth/_redux/authCrud";
import AccountsDashBoard from "../AccountsAndBilling/AccountsDashBoard";
import GroupDashboard from "../GroupDashboard/GroupDashboard";
import CTAModal from "../BookingDashboard/CTAModal";
import BookingDashboard from "../BookingDashboard/BookingDashboard";
import BookingDataLoader from "../BookingDashboard/BookingDataLoader";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CalculateIcon from "@mui/icons-material/Calculate";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import {
  djangoHandleDataRequests,
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../api";
import GroupAdmin from "../GroupAdmin/GroupAdmin";
import GroupMasterReport from "../GroupReports/GroupMasterReport";
import GroupSalesReport from "../GroupReports/GroupSalesReport";
import GroupChannelManagerReport from "../GroupReports/GroupChannelManagerReport";
import GroupReportsContainer from "../GroupReports/GroupReportsContainer";
import * as BsIcons from "react-icons/bs";
import * as MdIcons from "react-icons/md";
import MuiAppBar from "@mui/material/AppBar";
import {
  Divider,
  Stack,
  Box,
  Breadcrumbs,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Toolbar,
  IconButton,
  Button,
  Grid,
  OutlinedInput,
  MenuItem,
  Select,
  InputLabel,
  Tooltip,
} from "@mui/material";
import { useHtmlClassService } from "../../../_metronic/layout";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import KeyIcon from "@mui/icons-material/Key";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { getAllImagesAndUrl } from "../BookingDashboard/apis/BrandingModalApi";
import BulkInventory from "../BulkInventoryFlows/BulkInventory";
import GroupTimeline from "../CalendarPage/GroupTimeline";
import RoleAccess from "../../modules/Auth/pages/GroupAccessControl/RoleAccess";
import GroupUserAccess from "../../modules/Auth/pages/GroupAccessControl/GroupUserAccess";
import { Collapse } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SettingsIcon from "@mui/icons-material/Settings";
import GroupStats from "../GroupDashboard/Stats/GroupStats.js";
import AllGroupUsers from "../../modules/Auth/pages/GroupAccessControl/AllGroupUsers.js";
import { useTranslation } from "react-i18next";
import i18n from "../../modules/Auth/pages/i18n";
import NewGroupTimeline from "../CalendarPage/NewGroupTimeLine.js";
import NewGroup from "../CalendarPage/NewGroup.js";
import GroupBeConfig from "../BookingEngine/GroupBeConfig.js";
import { set } from "lodash";
import mainLogo from "../../../_metronic/layout/components/header/header-menu/sf logo.png";
import BookingDashboard2 from "../BookingDashboard/BookingDashboard2.jsx";
import { FormControl } from "react-bootstrap";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import MuiDrawer from "@mui/material/Drawer";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { isYes } from "../../Utils/Utils.js";
import BookingDataLoader2 from "../BookingDashboard/BookingDataLoader2.jsx";
import {
  setGroupDashboardHeader,
  setGroupSidebarOpen,
} from "../../../redux/uiSlice.js";
import GroupPerformanceDashboard from "../BookingDashboard/GroupPerformanceDashboard/GroupPerformanceDashboard.jsx";
import InsightsIcon from "@mui/icons-material/Insights";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const drawerWidth = 256;
const MINI_DRAWER_WIDTH = 64;
const NAVBAR_HEIGHT = 64;
const DRAWER_WIDTH = 256;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),

  // overflowX: "hidden",
  overflowX: "visible",
  width: `${DRAWER_WIDTH}px`,
  backgroundColor: "#111827",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // overflowX: "hidden",
  overflowX: "visible",
  width: `${MINI_DRAWER_WIDTH}px`,
  backgroundColor: "#111827",
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",

  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  position: "relative",
}));

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    // backgroundColor: "red",
    height: "100vh",

    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `${MINI_DRAWER_WIDTH}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),

      marginLeft: drawerWidth,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: `calc(100% - ${MINI_DRAWER_WIDTH}px)`,
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  backgroundColor: "white",
  boxShadow: "none",
  zIndex: 1,
}));

const SFListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: "48px",
  display: "flex",
  justifyContent: "center",
  color: "#fff",
  ".Mui-selected": {
    backgroundColor: "#333333",
    color: "#fff",
    "& .MuiListItemIcon-root": {
      color: "#fff",
    },
  },
}));

const SFListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: "0",
  height: "40px",
  borderRadius: "8px",
  "&:hover": {
    backgroundColor: "#1a1a1a",
  },
  "&:active": {
    backgroundColor: "#404f67",
  },
  ".Mui-selected": {
    backgroundColor: "#333333",
    color: "#fff",
    "& .MuiListItemIcon-root": {
      color: "#fff",
    },
  },
}));

const SFListItem = styled(ListItem)(({ theme }) => ({
  display: "block",
  borderRadius: "8px",
  mb: "8px",
  "&.Mui-selected": {
    backgroundColor: "#404f67",
    color: "#fff",
    "& .MuiListItemIcon-root": {
      color: "#fff",
    },
  },
}));

function GroupSidebar2({
  data,
  setAllHotels,
  setAccountingVersion,
  setAccountBalance,
  contentArea = null,
  hideDrawer = false,
  logoPath = null,
  selectedLanguage,
}) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  // STATES
  const ui = useSelector((state) => state.ui);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { email, token } = data;
  const [env, setEnv] = useState(process.env.REACT_APP_ENV);
  const [state, setState] = useState({
    left: false,
  });
  const [opens, setOpens] = useState(false);
  const [hotelStatus, setHotelStatus] = useState("ALL");
  const handleClick = () => {
    setOpens(!opens);
  };
  console.log("abhishek opens...", opens);
  // get the user logo
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      headerLogo: uiService.getLogo(),
    };
  }, [uiService]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const [groupState, setgroupState] = useState("Hotels dashboard");

  const [hotelIds, sethotelIds] = useState(null);
  const [groupId, setgroupId] = useState(null);
  const [firstHotelId, setFirstHotelId] = useState(null);
  const [bookingData, setBookingData] = useState(null);
  const [allHotelIds, setAllHotelIds] = useState([]);
  const [isGroup, setisGroup] = useState(false);
  const [groupEmail, setgroupEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [subUserAccess, setsubUserAccess] = useState("");
  const [showGroupAccess, setshowGroupAccess] = useState(false);

  useEffect(() => {
    setgroupEmail(localStorage.getItem("groupEmail"));
  }, [localStorage.getItem("groupEmail")]);

  const [loader, setloader] = useState(false);
  const getAllData = async () => {
    try {
      setloader(true);
      const data = await getHotel(email, true, token);
      setBookingData(data.data);
      localStorage.setItem(
        "groupEmail",
        data?.data?.filter((item) => item.status === "ACTIVE")[0].emailId
        // TODO: Uncomment this only when we have to test the group reports for test status hotels
        // data?.data?.filter((item) => item.status === "ACTIVE" || item.status === "TEST")[0].emailId
      );
      const tempHotelIds = data.data.map((res) => {
        return parseInt(res.hotelId);
      });
      let alltempHotels = data.data.map((res) => {
        if (res?.status === "ACTIVE" || res?.status === "TEST") {
          return { hotelId: res?.hotelId, hotelName: res?.hotelName };
        }
      });
      setAllHotelIds(alltempHotels);
      setloader(false);
      tempHotelIds.sort();
      sethotelIds(tempHotelIds);
      setFirstHotelId(tempHotelIds[0]);
      setAllHotels(data.data);
      setloader(false);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (
      userRole !== "" &&
      groupEmail !== "" &&
      groupEmail !== undefined &&
      groupEmail !== null &&
      groupEmail !== "null"
    ) {
      handleSpringDataRequest(
        `core/api/v1/groupAccesscontrol/addUserWizardRender?email=${localStorage.getItem(
          "HotelEmail"
        )}&hotelEmail=${groupEmail}`
      )
        .then((res) => {
          setsubUserAccess(res);
        })
        .catch((err) => console.error(err));
    }
  }, [groupEmail, userRole]);

  const [isAdmin, setisAdmin] = useState(false);
  useEffect(() => {
    if (bookingData?.length > 0) {
      handleSpringDataRequest(
        `core/api/v1/accesscontrol/addUserWizardRender?email=${localStorage.getItem(
          "HotelEmail"
        )}&hotelId=${bookingData[0].hotelId}&hotel_id=${bookingData[0].hotelId}`
      )
        .then((res) => {
          setisAdmin(
            res.ADMINRIGHTS === "ADMIN" || res.ADMINRIGHTS === "SUBADMIN"
          );
          localStorage.setItem(
            "isAdmin",
            res.ADMINRIGHTS === "ADMIN" || res.ADMINRIGHTS === "SUBADMIN"
          );
        })
        .catch((err) => console.error(err));
    }
  }, [bookingData]);

  const [allGroupId, setallGroupId] = useState("");
  useEffect(() => {
    if (
      groupEmail !== "" &&
      groupEmail !== undefined &&
      groupEmail !== null &&
      groupEmail !== "null"
    ) {
      handleSpringDataRequest(
        `core/api/v1/groupAccesscontrol/getGroupId?email=${groupEmail}`
      )
        .then((res) => {
          setallGroupId(res);
          localStorage.setItem("mainGroupId", res);
        })
        .catch((err) => console.error(err));
    }
  }, [groupEmail]);

  const getUserRole = () => {
    handleSpringDataRequest(
      `core/api/v1/groupaccess/getUserRole?userEmail=${email}`
    )
      .then((res) => {
        setUserRole(res);
      })
      .catch((err) => {
        console.log("the err is : ", err);
      });
  };

  useEffect(() => {
    getUserRole();
  }, []);

  const [accountInfo, setAccountInfo] = useState(null);
  const getCompanyData = (actId) => {
    handleSpringDataRequest(
      `core/api/v1/account/get-single/?groupId=${actId}&hotelId=${actId}`
    )
      .then((res) => {
        let vals = Object.keys(res);
        if (vals?.length > 0) {
          setAccountInfo(res);
          setAccountingVersion(res?.account_details?.accounting_version);
        }
      })
      .catch((err) => {
        console.log("the err is : ", err);
      });
  };

  useEffect(() => {
    // groupId && getCompanyData();
  }, [groupId]);

  const getActualGroupId = () => {
    if (groupId === null || groupId === undefined) {
      handleSpringDataRequest(
        `core/api/v1/account/get-accountId/?hotelId=${firstHotelId}&hId=${firstHotelId}`
      )
        .then((res) => {
          setgroupId(res);
          localStorage.setItem("actGroupId", res);
          localStorage.setItem("newGroupid", res);
          if (res !== "") {
            //Add groupId similar to how we added accounting version
            getCompanyData(res);
            handleSpringDataRequest(
              `core/api/v1/account-ledger/get-account-balance/?groupId=${res}&hotelId=${res}`
            )
              .then((resp) => {
                // setAccBalance(res?.message);
                setAccountBalance(resp.message);
              })
              .catch((err) => {
                console.log("the err is : ", err);
                // toast.error(err);
              });
          }
        })
        .catch((err) => {
          console.log("the err is : ", err);
        });
    }
  };

  useEffect(() => {
    firstHotelId && getActualGroupId();
  }, [firstHotelId]);

  // Opening the drawer
  // const [open, setOpen] = useState(false);
  const open = ui.groupSidebarOpen;
  const handleCloseDrawer = () => dispatch(setGroupSidebarOpen(false));
  useEffect(() => {
    if (hideDrawer) {
      handleCloseDrawer();
    }
  }, [hideDrawer]);

  // Current selected section
  const [currentSelected, setCurrentSelected] = useState("hotelDashboard");
  useEffect(() => {
    if (location.state && location.state.hasOwnProperty("selectedSection")) {
      setCurrentSelected(location.state.selectedSection);
    } else {
      setCurrentSelected("hotelDashboard");
    }
  }, [location]);

  const [groupBrandingData, setgroupBrandingData] = useState({});
  function getImgData() {
    getAllImagesAndUrl()
      .then((data) => setgroupBrandingData(data))
      .catch((err) => {
        throw new Error(err);
      });
  }

  useEffect(() => {
    getImgData();
  }, []);

  useEffect(() => {
    if (
      groupEmail !== null &&
      groupEmail !== undefined &&
      groupEmail !== "" &&
      groupEmail !== "null"
    ) {
      handleSpringDataRequest(
        `core/api/v1/reports/check-if-group-reports-enabled?emailId=${groupEmail}`
      )
        .then((res) => setisGroup(res))
        .catch((Err) => console.error(Err));
    }
  }, [groupEmail]);

  // Sections on the group dashboard
  const sections = [
    {
      name: `${t("Group dashboard")}`,
      headerName: `Welcome to your group dashboard`,
      indexName: "hotelDashboard",
      url: "/hotel-dashboard",
      subSection: [],
      icon: <HomeOutlinedIcon color="#fff" />,
      env: ["PROD", "BETA", "DJANGO_LOCAL", "LOCAL"],
      active: true,
      componentRenderer: (
        <BookingDashboard2
          bookingData={bookingData}
          freezed={accountInfo?.account_details?.freezed}
          groupBrandingData={groupBrandingData}
          getAllData={getAllData}
          selectedLanguage={selectedLanguage}
        />
      ),
    },
    {
      name: `${t("Group performance dashboard")}`,
      headerName: "Group performance dashboard",
      url: "/group-performance-dashboard",
      indexName: "GroupPerformanceDashboard",
      subSection: [],
      icon: <InsightsIcon />,
      env: ["PROD", "BETA", "DJANGO_LOCAL", "LOCAL"],
      active: true,
      componentRenderer: <GroupPerformanceDashboard />,
    },
    {
      name: `${t("Group reservation calendar")}`,
      headerName: "Reservation calendar",
      url: "/group-timeline",
      indexName: "groupTimeline",
      subSection: [],
      icon: <TravelExploreIcon color="#fff" />,
      env: ["BETA", "PROD", "DJANGO_LOCAL", "LOCAL"],
      active:
        bookingData?.filter((item) => item.status === "ACTIVE")?.length > 1,
      // subUserAccess !== "" &&
      // Object.entries(subUserAccess?.user_feature_map).length > 0 &&
      // subUserAccess?.user_feature_map?.GroupReservationCalendar !==
      //   undefined &&
      // JSON.parse(subUserAccess?.user_feature_map?.GroupReservationCalendar)
      //   .read === "YES",
      componentRenderer: <NewGroup bookingData={bookingData} />,
    },
    {
      name: `${t("Group Inventory calendar")}`,
      headerName: "Inventory calendar",
      url: "/bulkInventory",
      indexName: "GroupInventoryCalendar",
      subSection: [],
      icon: <KeyIcon color="#fff" />,
      env: ["PROD", "BETA", "DJANGO_LOCAL", "LOCAL"],
      active: false,
      // subUserAccess !== "" &&
      // Object.entries(subUserAccess?.user_feature_map).length > 0 &&
      // subUserAccess?.user_feature_map?.GroupInventoryCalendar !== undefined &&
      // JSON.parse(subUserAccess?.user_feature_map?.GroupInventoryCalendar)
      //   .read === "YES" &&
      // isGroup === "OK",
      componentRenderer: (
        <BulkInventory
          allHotelsData={bookingData}
          selectedLanguage={selectedLanguage}
        />
      ),
    },
    {
      name: `${t("Group reports")}`,
      headerName: "Reports",
      url: "/group-reports",
      indexName: "groupReports",
      subSection: [],
      icon: <AssessmentIcon color="#fff" />,
      env: ["PROD", "BETA", "DJANGO_LOCAL", "LOCAL"],
      active: [
        "stays@truliv.in",
        "support@mmrhotels.com",
        "arsh@tenpy.co",
        "info@bungalowsinlonavala.com",
        "eldenessaprod@example.com",
        "ankitsinhastayflexitest@gmail.com",
        "ota@ktdc.com",
        "reservation@maharashtratourism.gov.in",
        "ota@naptapgo.com",
        "madhur@sliceinn.in",
        // "dreamworks065@gmail.com",
        "collegeparkatlanta@gmail.com",
        "hotel1@example.com",
        "kumar699.abhishek@gmail.com",
        "gayathri.tie@gmail.com",
        "support@abodeatab.com",
        "bigfootoperations@gmail.com",
        "reservations@mangrovestays.com",
        "homeslicestaysoffice@gmail.com",
        "manish.kumar@nia.one",
        "vc@manpeksha.com",
        "info@youngmonkhostel.com",
        "reservation@maharashtratourism.gov.in",
        "madhur@sliceinn.in",
        "bigfootoperations@gmail.com",
        "pavan.varanasi@stayflexi.com",
        "arun.e@stayflexi.com",
        "privy.stays@gmail.com",
      ].includes(groupEmail),
      // active: false,
      // subUserAccess !== "" &&
      // Object.entries(subUserAccess?.user_feature_map).length > 0 &&
      // subUserAccess?.user_feature_map?.GroupReports !== undefined &&
      // JSON.parse(subUserAccess?.user_feature_map?.GroupReports).read ===
      //   "YES",
      componentRenderer: (
        <GroupReportsContainer
          email={email}
          selectedLanguage={selectedLanguage}
        />
      ),
    },

    {
      name: `${t("Accounts and billing")}`,
      headerName: "Accounts and billing",
      indexName: "accountsAndBilling",
      url: "/accounts-billing",
      subSection: [],
      icon: <CalculateIcon />,
      env: ["PROD", "BETA", "DJANGO_LOCAL", "LOCAL"],
      active:
        accountInfo &&
        accountInfo?.account_details?.accounting_version === 2 &&
        subUserAccess?.ADMINRIGHTS?.toLowerCase() === "admin",
      componentRenderer: (
        <AccountsDashBoard
          bookingData={bookingData}
          hotelIds={hotelIds}
          groupId={groupId}
        />
      ),
    },

    {
      name: `${t("Validate travel agent")}`,
      headerName: "Travel agent",
      url: "/travel-agents",
      indexName: "travelAgents",
      subSection: [],
      icon: <TravelExploreIcon color="#fff" />,
      env: ["BETA", "PROD", "DJANGO_LOCAL", "LOCAL"],
      active:
        email === "reservation@maharashtratourism.gov.in" ||
        email === "onlinesales@teamdelight.co.in",
      componentRenderer: <CTAModal allActiveHotels={allHotelIds} />,
    },
    // {
    //   name: "Group Statistics",
    //   url: "/group-dashboard",
    //   indexName: "groupDashboard",
    //   subSection: [],
    //   icon: <DashboardIcon />,
    //   env: ["BETA", "DJANGO_LOCAL", "PROD", "LOCAL"],
    //   active: false,
    //   // subUserAccess !== "" &&
    //   // Object.entries(subUserAccess?.user_feature_map).length > 0 &&
    //   // subUserAccess?.user_feature_map?.GroupStatistics !== undefined &&
    //   // JSON.parse(subUserAccess?.user_feature_map?.GroupStatistics).read ===
    //   //   "YES",
    //   // componentRenderer: (
    //   //   <GroupDashboard
    //   //     bookingData={bookingData && bookingData}
    //   //     hotelIds={hotelIds && hotelIds}
    //   //   />
    //   // ),
    //   componentRenderer: (
    //     <GroupStats
    //       bookingData={bookingData}
    //       hotelIds={hotelIds}
    //       groupEmail={groupEmail}
    //       fullScreen={!open}
    //       selectedLanguage={selectedLanguage}
    //     />
    //   ),
    // },

    {
      name: "Group Booking Engine",
      headerName: "Booking engine",
      url: "/groupBeConfig",
      indexName: "groupBeConfig",
      subSection: [],
      icon: <DashboardIcon color="#fff" />,
      env: ["BETA", "DJANGO_LOCAL", "PROD", "LOCAL"],
      active:
        bookingData?.filter((item) => item.status === "ACTIVE")?.length > 1,
      componentRenderer: <GroupBeConfig bookingData={bookingData} />,
    },

    {
      name: `${t("Access Control")}`,
      headerName: "Access controls",
      url: "/travel-agents",
      indexName: "travelAgents",
      subSection: [
        {
          name: "Create Admin User",
          headerName: "Access controls",
          url: "/group-access-control",
          indexName: "groupAccessControl",
          subSection: [],
          icon: <KeyIcon />,
          env: ["PROD", "BETA", "DJANGO_LOCAL", "LOCAL"],
          active:
            userRole?.toLowerCase() === "admin" ||
            userRole?.toLowerCase() === "subadmin",
          // (subUserAccess !== "" &&
          //   Object.entries(subUserAccess?.user_feature_map).length > 0 &&
          //   subUserAccess?.user_feature_map?.GroupUsersAndAccess !==
          //     undefined &&
          //   JSON.parse(subUserAccess?.user_feature_map?.GroupUsersAndAccess)
          //     .read === "YES"),
          componentRenderer: (
            <GroupAdmin
              bookingData={bookingData && bookingData}
              hotelIds={hotelIds && hotelIds}
              groupId={allGroupId && allGroupId}
              selectedLanguage={selectedLanguage}
            />
          ),
        },
        {
          name: `${t("Copy / Assign Users")}`,
          headerName: "Access controls",
          indexName: "access-control",
          url: "/access-control",
          subSection: [],
          icon: <CalculateIcon />,
          env: ["PROD", "BETA", "DJANGO_LOCAL", "LOCAL"],
          active:
            userRole?.toLowerCase() === "admin" ||
            userRole?.toLowerCase() === "subadmin",
          componentRenderer: (
            <AllGroupUsers
              bookingData={bookingData && bookingData}
              hotelIds={hotelIds && hotelIds}
              allGroupId={allGroupId}
              groupEmail={groupEmail}
              env={env}
              selectedLanguage={selectedLanguage}
            />
          ),
        },
        {
          name: `${t("Roles")}`,
          headerName: "Access controls",
          url: "/group-access-role",
          indexName: "GroupAccessRole",
          subSection: [],
          icon: <DashboardIcon />,
          env: ["BETA", "DJANGO_LOCAL", "PROD", "LOCAL"],
          active: false,
          // userRole?.toLowerCase() === "admin" ||
          // userRole?.toLowerCase() === "subadmin",
          componentRenderer: (
            <RoleAccess
              bookingData={bookingData && bookingData}
              hotelIds={hotelIds && hotelIds}
              allGroupId={allGroupId}
              groupEmail={groupEmail}
              selectedLanguage={selectedLanguage}
            />
          ),
        },
        {
          name: `${t("User")}`,
          headerName: "Access controls",
          url: "/group-access-user",
          indexName: "GroupAccessUser",
          subSection: [],
          icon: <DashboardIcon />,
          env: ["BETA", "DJANGO_LOCAL", "PROD", "LOCAL"],
          active: false,
          // userRole?.toLowerCase() === "admin" ||
          // userRole?.toLowerCase() === "subadmin",
          componentRenderer: (
            <GroupUserAccess
              bookingData={bookingData && bookingData}
              hotelIds={hotelIds && hotelIds}
              allGroupId={allGroupId}
              groupEmail={groupEmail}
              selectedLanguage={selectedLanguage}
            />
          ),
        },
      ],
    },
  ];

  useEffect(() => {
    const data = sections[8]?.subSection.filter(
      (section, idx) => section.active === true
    );

    setshowGroupAccess(data.length > 0);
  }, [userRole, subUserAccess]);

  // Handle selected function
  function handleSelected(index) {
    if (index === currentSelected) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    getAllData();
  }, []);

  useEffect(() => {
    let headerNameIdx = sections.findIndex(
      (item) => item.indexName === location?.state?.selectedSection
    );
    if (headerNameIdx === -1) headerNameIdx = 0;

    dispatch(setGroupDashboardHeader(sections[headerNameIdx].headerName));
  }, [location?.state?.selectedSection]);

  const list = (
    <Stack sx={{ overflow: "hidden" }}>
      <List
        sx={{
          px: "8px",
        }}
      >
        {sections?.map(
          (section, idx) =>
            section.active &&
            section.env.includes(env.toUpperCase()) &&
            section.subSection.length === 0 && (
              <SFListItem
                key={idx}
                disablePadding
                selected={handleSelected(section.indexName)}
                onClick={() => {
                  if (!isYes(accountInfo?.account_details?.freezed)) {
                    setCurrentSelected(section.indexName);
                    dispatch(setGroupDashboardHeader(section.headerName));
                    history.push({
                      pathname: "/hotel-dashboard",
                      state: { selectedSection: section.indexName },
                    });
                  }
                }}
                // as={Link}
                // to={{
                //   pathname: section.url,
                //   state: {
                //     bookingData: bookingData && bookingData,
                //     hotelIds: hotelIds && hotelIds,
                //     groupId: groupId && groupId,
                //     allActiveHotels: allHotelIds && allHotelIds,
                //   },
                // }}
              >
                <SFListItemButton>
                  <SFListItemIcon>{section.icon}</SFListItemIcon>

                  <ListItemText
                    sx={[
                      { color: "#fff" },
                      open
                        ? {
                            opacity: 1,
                          }
                        : {
                            opacity: 0,
                          },
                    ]}
                  >
                    {section.name}
                  </ListItemText>
                </SFListItemButton>
              </SFListItem>
            )
        )}{" "}
        {showGroupAccess && (
          <SFListItem
            disablePadding
            onClick={() => {
              if (!isYes(accountInfo?.account_details?.freezed)) {
                handleClick();
              }
            }}
          >
            <SFListItemButton>
              <SFListItemIcon>
                <SettingsIcon />
              </SFListItemIcon>
              <ListItemText
                sx={[
                  { color: "#fff" },
                  open
                    ? {
                        opacity: 1,
                      }
                    : {
                        opacity: 0,
                      },
                ]}
                primary={`${t("Access Control")}`}
              />
              {open && (
                <Box pr={1}>
                  {opens ? (
                    <KeyboardArrowUpIcon sx={{ color: "#fff" }} />
                  ) : (
                    <KeyboardArrowDownIcon sx={{ color: "#fff" }} />
                  )}
                </Box>
              )}
            </SFListItemButton>
          </SFListItem>
        )}
        <Collapse in={opens} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {sections[8].subSection?.map(
              (section, idx) =>
                section.active &&
                section.env.includes(env.toUpperCase()) && (
                  <SFListItem
                    key={idx}
                    disablePadding
                    selected={handleSelected(section.indexName)}
                    onClick={() => {
                      setCurrentSelected(section.indexName);
                      dispatch(setGroupDashboardHeader(section.headerName));
                      history.push({
                        pathname: "/hotel-dashboard",
                        state: { selectedSection: section.indexName },
                      });
                    }}
                  >
                    <SFListItemButton>
                      <SFListItemIcon>{section.icon}</SFListItemIcon>
                      <ListItemText
                        sx={[
                          { color: "#fff" },
                          open
                            ? {
                                opacity: 1,
                              }
                            : {
                                opacity: 0,
                              },
                        ]}
                      >{`${t(section.name)}`}</ListItemText>
                    </SFListItemButton>
                  </SFListItem>
                )
            )}
          </List>
        </Collapse>
      </List>
    </Stack>
  );
  const removeToken = () => {
    fetch(
      `${
        process.env.REACT_APP_SPRING_API_URL
      }common/logout-remove-user-token?&email=${localStorage.getItem(
        "HotelEmail"
      )}`,
      {
        method: "GET",
        headers: {
          Token: localStorage.getItem("token"),
        },
      }
    )
      .then((data) => console.log("logout-remove-user-token", data))
      .catch((error) =>
        console.error("Error logout-remove-user-token :", error)
      );
  };
  const handleDrawerOpen = () => {
    // setOpen(true);
    dispatch(setGroupSidebarOpen(true));
  };

  const handleDrawerClose = () => {
    // setOpen(false);
    dispatch(setGroupSidebarOpen(false));
  };

  const isWhiteLabelled = "ENABLED" === groupBrandingData.status;

  return (
    <Stack
      sx={{
        display: "flex",
        width: "100vw",
        height: "100vh",

        ...(currentSelected === "GroupPerformanceDashboard" && {
          bgcolor: "black",
        }),
      }}
    >
      {/* NAV BAR  */}
      {/* <AppBar position="fixed" open={open}>
        <Toolbar
          sx={{
            boxShadow: "none",
            ...(currentSelected === "GroupPerformanceDashboard" && {
              bgcolor: "black",
            }),
          }}
        >
          <Stack
            className="position-relative"
            direction="row"
            flex={1}
            spacing={2}
            style={{ width: "100%" }}
          >
            {/* Side drawer menu icon  */}
      {/* <Stack
              style={{
                marginTop: "auto",
                marginBottom: "auto",
                cursor: "pointer",
              }}
            >
              <Typography onClick={() => setOpen((prev) => !prev)}>
                <BsIcons.BsList size="18px" color="black" />
              </Typography>
            </Stack> */}

      {/* App logo  */}
      {/* <Grid container>
              <Grid item></Grid>
              <Grid item container>
                <Grid item>
                  <Box>
                    <OutlinedInput
                      // onChange={onFilterTextChange}
                      placeholder={`${t("Search Hotels")}`}
                      label={`${t("Search Hotels")}`}
                      // className="w-75"
                      notched={false}
                      type="search"
                      size="small"
                      style={{
                        boxShadow: "0px 0px 16px 6px #0000001a",
                        borderRadius: "5px",
                        backgroundColor: "white",
                        width: "63%",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item>
                  <Box>
                    <FormControl
                      size="small"
                      sx={{
                        width: "20%",
                        marginLeft: "3%",
                        boxShadow: "0px 0px 16px 6px #0000001a",
                        borderRadius: "5px",
                        backgroundColor: "white",
                      }}
                    >
                      <InputLabel id="hotel-status-label">
                        {t("Hotel Status")}
                      </InputLabel>
                      <Select
                        labelId="hotel-status-label" // ✅ connects Select to InputLabel
                        id="hotel-status-select"
                        value={hotelStatus}
                        onChange={(e) => setHotelStatus(e.target.value)}
                        label={t("Hotel Status")}
                      >
                        {[
                          "ALL",
                          "ACTIVE",
                          "INACTIVE",
                          "TRIAL",
                          "INQUIRY",
                          "ONBOARDING PENDING",
                          "TEST",
                        ].map((item) => (
                          <MenuItem key={item} value={item}>
                            {t(item) || item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </Grid> */}

      {/* <Typography
              color="primary"
              sx={{
                fontSize: "32px",
                fontWeight: 800,
                ...(currentSelected === "GroupPerformanceDashboard" && {
                  color: "white",
                }),
              }}
            >
              {ui.groupDashboardHeader}
            </Typography> */}

      {/* </Stack> */}

      {/* Sign out button  */}
      {/* //     <Stack style={{ marginTop: "auto", marginBottom: "auto" }}>
      //       <Typography>
      //         <DomLink to="/logout">
      //           <Button variant="outlined-clean" onClick={() => removeToken()}>
      //             {`${t("Sign out")}`}
      //           </Button>
      //         </DomLink>
      //       </Typography>
      //     </Stack>
      //   </Toolbar> */}
      {/* // </AppBar>  */}

      {/* SIDE DRAWER  */}
      <Drawer
        variant="permanent"
        open={open}
        sx={{
          flex: 1,
          "& .MuiDrawer-paper": {
            overflow: "visible",
          },
        }}
      >
        <DrawerHeader sx={{ overflow: "visible" }}>
          {Object.keys(groupBrandingData).length > 0 && !isWhiteLabelled && (
            // STAYFLEXI LOGO
            <img
              src={`/media/sf-logo/2${open ? "_expanded" : ""}.png`}
              height={open ? "40px" : "48px"}
              width={"48px"}
              alt="logo"
              style={{ filter: "invert(1)" }}
            />
          )}
          {Object.keys(groupBrandingData).length > 0 && isWhiteLabelled && (
            // WHITELABELLED LOGO
            <img
              src={groupBrandingData?.logoUrl}
              height={"48px"}
              width={"48px"}
              alt="logo"
              style={{
                objectFit: "contain",
                overflow: "hidden",
              }}
            />
          )}
          {/* Toggle Drawer Button */}
          <IconButton
            onClick={open ? handleDrawerClose : handleDrawerOpen}
            sx={{
              position: "absolute",
              right: 0,
              top: "50%",
              height: "16px",
              width: "16px",
              transform: "translate(50% , -50%)",
              backgroundColor: "#404f67",
              padding: "4px",
              "&:hover": {
                backgroundColor: "#2e3a4d",
              },
            }}
          >
            {open ? (
              <ChevronLeftIcon sx={{ color: "#fff" }} />
            ) : (
              <ChevronRightIcon sx={{ color: "#fff" }} />
            )}
          </IconButton>
          {/* {open ? (
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          ) : (
            <Button onClick={handleDrawerOpen}>s</Button>
          )} */}
        </DrawerHeader>
        <Divider />
        <Stack>{list}</Stack>

        <Stack
          justifyContent={"flex-end"}
          alignItems={"center"}
          flex={1}
          spacing={2}
          pb={2}
          overflow={"hidden"}
        >
          <Tooltip title="logout" placement="right">
            <SFListItem sx={{ px: "8px", justifyContent: "flex-end" }}>
              <DomLink to="/logout">
                <SFListItemButton
                  sx={{ justifyContent: "center" }}
                  onClick={removeToken}
                >
                  <SFListItemIcon>{<ExitToAppIcon />}</SFListItemIcon>

                  <ListItemText
                    sx={{
                      color: "#fff",
                      ...(open
                        ? {
                            opacity: 1,
                          }
                        : {
                            opacity: 0,
                          }),
                      flexGrow: 0,
                    }}
                  >
                    Logout
                  </ListItemText>
                </SFListItemButton>
              </DomLink>
            </SFListItem>
          </Tooltip>

          {Object.keys(groupBrandingData).length > 0 &&
            !isWhiteLabelled &&
            open && (
              <Stack>
                <Typography color={"white"}>
                  Copyright ©2025 Stayflexi Inc
                </Typography>
                <Stack alignItems={"center"} justifyContent={"center"}>
                  <a
                    href="https://business.stayflexi.com/terms"
                    target="_blank"
                    style={{
                      color: "white",
                      textDecoration: "underline",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#a0a0a0")}
                    onMouseLeave={(e) => (e.target.style.color = "gray")}
                  >
                    Stayflexi platform terms
                  </a>
                  <a
                    href="https://business.stayflexi.com/privacy-policy"
                    target="_blank"
                    style={{
                      color: "white",
                      textDecoration: "underline",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#a0a0a0")}
                    onMouseLeave={(e) => (e.target.style.color = "gray")}
                  >
                    Privacy policy
                  </a>
                </Stack>
              </Stack>
            )}
        </Stack>
      </Drawer>

      {/* MAIN CONTENT  */}
      <Main open={open}>
        {contentArea}
        {location?.state?.selectedSection === currentSelected &&
          !location.state.childSection &&
          (bookingData ? (
            sections
              .filter((section) => section.indexName === currentSelected)
              .map((sec) => (
                <Stack
                  style={{
                    position: "relative",
                    height: "100%",
                    ...(currentSelected === "GroupPerformanceDashboard" && {
                      bgcolor: "black",
                    }),
                  }}
                  sx={{
                    px: "24px",
                    py: "16px",
                  }}
                >
                  {sec.componentRenderer}
                </Stack>
              ))
          ) : (
            <Box
              sx={{
                px: "24px",
                py: "16px",
                ...(currentSelected === "GroupPerformanceDashboard" && {
                  bgcolor: "black",
                }),
              }}
            >
              <BookingDataLoader2 />
            </Box>
          ))}

        {location?.state?.selectedSection === currentSelected &&
          !location.state.childSection &&
          (bookingData ? (
            sections[8].subSection
              .filter((section) => section.indexName === currentSelected)
              .map((sec) => (
                <Stack
                  style={{
                    position: "relative",
                    height: "100%",
                    ...(currentSelected === "GroupPerformanceDashboard" && {
                      bgcolor: "black",
                    }),
                  }}
                  sx={{
                    px: "24px",
                    py: "16px",
                  }}
                >
                  {sec.componentRenderer}
                </Stack>
              ))
          ) : (
            <Box
              sx={{
                px: "24px",
                py: "16px",
                ...(currentSelected === "GroupPerformanceDashboard" && {
                  bgcolor: "black",
                }),
              }}
            >
              <BookingDataLoader2 />
            </Box>
          ))}
      </Main>
    </Stack>
  );
}

function mapStateToProps(state) {
  return { data: state.auth };
}

export default connect(mapStateToProps, auth.actions)(GroupSidebar2);
